import { Reveal, SectionLabel } from "./Reveal";
import { ArrowUpRight } from "lucide-react";

const projects = [
  {
    img: "https://images.unsplash.com/photo-1712730642507-d4ad0904e997?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwyfHxtb2Rlcm4lMjBjYWZlJTIwaW50ZXJpb3IlMjBtaW5pbWFsfGVufDB8fHx8MTc4Mzk1MjQ4Nnww&ixlib=rb-4.1.0&q=85",
    tag: "Café & Rösterei",
    name: "Kaffeewerk Ratingen",
    result: "+65 % Online-Reservierungen",
  },
  {
    img: "https://images.unsplash.com/photo-1628012209120-d9db7abf7eab?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzR8MHwxfHNlYXJjaHwxfHxtaW5pbWFsaXN0JTIwYXJjaGl0ZWt0dXJlJTIwbW9kZXJufGVufDB8fHx8MTc4Mzk1MjQ4Nnww&ixlib=rb-4.1.0&q=85",
    tag: "Immobilienmakler",
    name: "Brandt Immobilien",
    result: "Platz 2 bei Google in 8 Wochen",
  },
  {
    img: "https://images.unsplash.com/photo-1685602729695-0664ea4e5c06?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHwxfHxtb2Rlcm4lMjBjYWZlJTIwaW50ZXJpb3IlMjBtaW5pbWFsfGVufDB8fHx8MTc4Mzk1MjQ4Nnww&ixlib=rb-4.1.0&q=85",
    tag: "Physiotherapie",
    name: "Praxis Mertens",
    result: "+40 % Neupatienten-Anfragen",
  },
];

export default function Portfolio() {
  return (
    <section id="referenzen" className="py-20 md:py-32">
      <div className="max-w-6xl mx-auto px-5 md:px-8">
        <Reveal>
          <SectionLabel number="05" label="Referenzen" />
          <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
            <h2 className="font-display font-medium text-3xl md:text-4xl lg:text-5xl tracking-tight max-w-xl">
              Projekte, die für ihre Besitzer arbeiten.
            </h2>
            <p className="text-[#52525B] max-w-sm leading-relaxed">
              Eine Auswahl aktueller Arbeiten — jedes Projekt mit messbarem Ergebnis.
            </p>
          </div>
        </Reveal>
        <div className="mt-14 grid md:grid-cols-3 gap-5">
          {projects.map((p, i) => (
            <Reveal key={p.name} delay={i * 0.12}>
              <a href="#kontakt" className="group block" data-testid={`portfolio-card-${i}`}>
                <div className="relative rounded-2xl overflow-hidden aspect-[4/3] border border-[#E4E4E7]">
                  <img
                    src={p.img}
                    alt={`Website-Projekt für ${p.name}`}
                    loading="lazy"
                    className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A]/60 via-transparent to-transparent" />
                  <span className="absolute top-3 left-3 rounded-full bg-white/85 backdrop-blur-sm font-mono text-[10px] uppercase tracking-wider px-3 py-1.5">
                    {p.tag}
                  </span>
                  <ArrowUpRight className="absolute top-3 right-3 w-8 h-8 p-1.5 rounded-full bg-white text-[#0A0A0A] opacity-0 translate-y-1 group-hover:opacity-100 group-hover:translate-y-0 transition-[opacity,transform] duration-300" aria-hidden="true" />
                </div>
                <div className="mt-4 flex items-start justify-between gap-3">
                  <h3 className="font-display font-semibold tracking-tight">{p.name}</h3>
                  <span className="font-mono text-xs text-[#2563EB] font-medium whitespace-nowrap mt-0.5">{p.result}</span>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
}
